import { render, staticRenderFns } from "./add-more-candidate-new-job.vue?vue&type=template&id=4a4c15c2&scoped=true"
import script from "./add-more-candidate-new-job.vue?vue&type=script&lang=ts"
export * from "./add-more-candidate-new-job.vue?vue&type=script&lang=ts"
import style0 from "./add-more-candidate-new-job.vue?vue&type=style&index=0&id=4a4c15c2&prod&lang=scss&scoped=true"
import style1 from "./add-more-candidate-new-job.vue?vue&type=style&index=1&id=4a4c15c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4c15c2",
  null
  
)

export default component.exports